import { render, staticRenderFns } from "./UserPhoneChanged.vue?vue&type=template&id=e2c21fe6&scoped=true"
import script from "./UserPhoneChanged.vue?vue&type=script&lang=js"
export * from "./UserPhoneChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c21fe6",
  null
  
)

export default component.exports